import React, { useEffect, useState } from "react";
import history from "../../history";
import { Row, Col, Card, CardBody } from "reactstrap";
import { Tabs, Tab } from "react-bootstrap";
import { fetchQueryParams } from "../../utils/comman";
import CartTitle from "../CartTitle";
import RideMainDetail from "../RideMainDetail";
import JoinUserList from "../JoinRideUserList";
import JoinUser from "../JoinUsers";

import get from "lodash/get";

const _ = { get };

const initialState = {
  formId: "",
  status: "PENDING",
  rejectionReason: "",
  toggleRejectModal: false,
  key: "ride-detail",
  displayName: "Admin",
};

function rideDetail(props) {
  let { elements } = props;
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (props.selectedId) {
      props.handleFetchSingleRide(props.selectedId);
    }
  }, [props.selectedId]);

  console.log("selectedID", props);
  console.log("idd", props.selectedId);

  const handleSelectTab = (tab) => {
    state.key = tab;
    setState({ ...state });
    const params = fetchQueryParams(props.query);

    if (tab === "ride-detail") {
      props.handleFetchSingleRide(props.selectedId);
    } else {
      let data = {
        status: state.status,
        id: props.selectedId,
      };
      props.handleUsersForJoinRide(data);
    }
    props.handleClearPreviousReducer();
  };

  useEffect(() => {
    let newState = { ...state };
    newState.key = "ride-detail";
    setState(newState);
  }, []);

  console.log("tab", state.key);
  return (
    <React.Fragment>
      <div className="hideSearch">
        <Row>
          <Col sm={12}>
            <CartTitle
              title={_.get(
                elements,
                "rideDetailElement.headingElement",
                "Ride Details"
              )}
              customClass={"hidebtn"}
              iconClass={"hideexcel"}
              innerTextClass={"hidetext"}
            />
          </Col>
        </Row>

        <Card className="mb-3">
          <CardBody className="px-0 px-lg-1 py-0 py-lg-1">
            <Row className="custom-tab">
              <Col sm={12}>
                <Tabs
                  id="tab-id"
                  activeKey={state.key}
                  onSelect={(k) => handleSelectTab(k)}
                >
                  <Tab
                    eventKey="ride-detail"
                    title={_.get(
                      elements,
                      "rideDetailElement.tabDetailElement",
                      "Detail"
                    )}
                  >
                    <RideMainDetail
                      page={props.page}
                      query={props.query}
                      displayName={state.displayName}
                      singleRide={props.singleRide}
                      handleRideModeration={props.handleRideModeration}
                      handleRideGallery={props.handleRideGallery}
                      handleFetchSingleRide={props.handleFetchSingleRide}
                      singleRideStatus={props.singleRideStatus}
                      elements={props.elements}
                      moderateRideGalleyStatus={props.moderateRideGalleyStatus}
                      selectedId={props.selectedId}
                      status={props.status}
                      handleToggleModel={props.handleToggleModel}
                    />
                  </Tab>
                  <Tab
                    eventKey="join-ride"
                    title={_.get(
                      elements,
                      "rideDetailElement.tabJoinRideElement",
                      "All Applicants"
                    )}
                    disabled={
                      props.singleRide !== null
                        ? props.singleRide.moderationStatus !== "PENDING" &&
                          props.singleRide.moderationStatus !== "REJECTED"
                          ? false
                          : true
                        : null
                    }
                  >
                    <JoinUserList
                      elements={props.elements}
                      handleUsersForJoinRide={props.handleUsersForJoinRide}
                      usersToJoinRideStatus={props.usersToJoinRideStatus}
                      usersToJoinRide={props.usersToJoinRide}
                      handleUsersModerationForJoinRide={
                        props.handleUsersModerationForJoinRide
                      }
                      singleRide={props.singleRide}
                      moderationStatusForUser={props.moderationStatusForUser}
                      query={props.query}
                      selectedId={props.selectedId}
                      handleToggleModel={props.handleToggleModel}
                    />
                  </Tab>
                  <Tab
                    eventKey="add-user-ride"
                    title={_.get(
                      elements,
                      "rideDetailElement.addUserElement",
                      "Add Participant"
                    )}
                    disabled={
                      props.singleRide !== null
                        ? props.singleRide.moderationStatus !== "PENDING" &&
                          props.singleRide.moderationStatus !== "REJECTED"
                          ? false
                          : true
                        : null
                    }
                  >
                    <JoinUser
                      elements={props.elements}
                      handleFetchAllUser={props.handleFetchAllUser}
                      handleClearPreviousReducer={
                        props.handleClearPreviousReducer
                      }
                      allUserStatus={props.allUserStatus}
                      allUser={props.allUser}
                      handleUsersForJoinRide={props.handleUsersForJoinRide}
                      usersToJoinRideStatus={props.usersToJoinRideStatus}
                      usersToJoinRide={props.usersToJoinRide}
                      handleUsersModerationForJoinRide={
                        props.handleUsersModerationForJoinRide
                      }
                      handleJoinUser={props.handleJoinUser}
                      singleRide={props.singleRide}
                      moderationStatusForUser={props.moderationStatusForUser}
                      query={props.query}
                      selectedId={props.selectedId}
                      tab={state.key}
                      handleToggleModel={props.handleToggleModel}
                    />
                  </Tab>
                  {/* <Tab
                    eventKey="image-moderation"
                    title={_.get(
                      elements,
                      "rideDetailElement.imageModerationElement",
                      "Image Moderation"
                    )}
                    disabled={
                      props.singleRide !== null
                        ? props.singleRide.moderationStatus !== "PENDING" &&
                          props.singleRide.moderationStatus !== "REJECTED" &&
                          props.singleRide.rideStatus !== "COMPLETED"
                          ? false
                          : true
                        : null
                    }
                  >
                    <ImageModeration
                      elements={props.elements}
                      handleFetchAllUser={props.handleFetchAllUser}
                      handleClearPreviousReducer={
                        props.handleClearPreviousReducer
                      }
                      handleFetchImagesForModeration={
                        props.handleFetchImagesForModeration
                      }
                      allUserStatus={props.allUserStatus}
                      allUser={props.allUser}
                      handleUsersForJoinRide={props.handleUsersForJoinRide}
                      usersToJoinRideStatus={props.usersToJoinRideStatus}
                      usersToJoinRide={props.usersToJoinRide}
                      handleUsersModerationForJoinRide={
                        props.handleUsersModerationForJoinRide
                      }
                      handleJoinUser={props.handleJoinUser}
                      singleRide={props.singleRide}
                      moderationStatusForUser={props.moderationStatusForUser}
                      query={props.query}
                    />
                  </Tab> */}
                </Tabs>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  );
}

export default rideDetail;
